import Objdict from "objdict"

import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Zone from "@frog/source/models/Zone.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

import Geometry from "@frog/source/utility/Geometry.js"
import Audiomix from "@frog/source/engine/Audiomix.js"
import Timings from "@frog/source/engine/animating/utility/Timings.js"
import * as Motions from "@frog/source/engine/animating/utility/Motions.js"
import GameAnalytics from "not-game-analytics"

import unitJobs from "@frog/source/data/unitJobs.js"

function Stepdeltastage(deltastages, duration) {
    if(deltastages instanceof Array == false) {
        deltastages = [deltastages]
    }
    return {
        "duration": duration,
        "deltastages": deltastages
    }
}


// - making functions that return plotscripts

// {
//     "func": () => {}
// }

// {
//     "alphastage": ...,
//     "omegastage": ...,
//     "deltastages": [
//         // ...
//     ]
// }

// "GUY: Hello World!!"

// You can also return these steps from a dynamic function!
// If you want to conditionally or dynamically generate the
// step, you'll need to wrap it in a function, like this:
// (stage) => {
//     return {
//         "deltastages": [
//             // ...
//         ]
//     }
// }

// Where are steps used?
// - Unit.calculateActions() includes steps
// - unit.skillKeys (or unit.skillKeys or unit.inventory[x].skillKeys) can generate steps!!
// - chapter.scripts generate steps!!
// - unit.dialogue includes steps - some of it is generated when a unit dies!!
// game.openingEvents


// static deltastage(deltastages, duration) {
//     if(deltastages instanceof Array == false) {
//         deltastages = [deltastages]
//     }
//     return {
//         "duration": duration,
//         "deltastages": deltastages
//     }
// }

export function KillUnit({unitKey, duration = 300}) {
    return {
        "name": "death",
        "type": "invoke skill",
        "deltastages": [
            {
                "mark": 0,
                "audio": {"triggerKey": "Unit:Death"},
            },
            {
                "mark": 0,
                "unit": {"key": unitKey, "opacity": 1}
            },
            {
                "mark": duration,
                "unit": {"key": unitKey, "opacity": 0}
            },
            {
                "mark": duration,
                "unit": {"key": unitKey, "isDead": true}
            },
            {
                "mark": duration,
            }
        ]
    }
}

export function ShudderUnit({unitKey}) {
    return (stage) => {
        const SHUDDER = 0.1

        const unit = stage.units[unitKey]
        if(unit == undefined) return

        return {
            "type": "invoke skill",
            "duration": 18 * 25,
            "deltastages": stage.random.shuffle([
                {"x": 0, "y": -SHUDDER},
                {"x": 0, "y": SHUDDER},
                {"x": SHUDDER, "y": 0},
                {"x": -SHUDDER, "y": 0},
                {"x": SHUDDER, "y": -SHUDDER},
                {"x": -SHUDDER, "y": SHUDDER},
                {"x": SHUDDER, "y": -SHUDDER},
                {"x": -SHUDDER, "y": SHUDDER},
                {"x": 0, "y": -SHUDDER},
                {"x": 0, "y": SHUDDER},
                {"x": SHUDDER, "y": 0},
                {"x": -SHUDDER, "y": 0},
                {"x": SHUDDER, "y": -SHUDDER},
                {"x": -SHUDDER, "y": SHUDDER},
                {"x": SHUDDER, "y": -SHUDDER},
                {"x": -SHUDDER, "y": SHUDDER},
            ]).concat([
                {"x": 0, "y": 0},
            ]).map((deltaposition, index) => {
                return {
                    "mark": index * 25,
                    "unit": {
                        "key": unitKey,
                        "position": Geometry.add(unit.position, deltaposition)
                    }
                }
            })
        }
    }
}

// Navigation //

export function Go(url) {
    return {
        "func": () => Navigation.go(url)
    }
}

// Conditionals //

export function ifUnitIsAliveAndAllied(unitKey, events) {
    return (stage) => {
        if(stage.units[unitKey] != undefined
        && stage.units[unitKey].isDead != true
        && stage.units[unitKey].isRemoved != true
        && stage.units[unitKey].affiliation == stage.player.affiliation) {
            return events
        }
    }
}

export function ifFlagIsValue(flagname, value, events) {
    return (stage) => {
        if(stage.flags[flagname] == value) {
            return events
        }
    }
}

export function ifFlagsMeetCondition(condition, events) {
    return (stage) => {
        if(condition(stage.flags) == true) {
            return events
        }
    }
}

// Modals //

export function Dialogue(dialogue) {
    if(dialogue.data != undefined
    && dialogue.data.speakerKey != undefined
    && dialogue.data.scene == undefined) {
        dialogue.data.scene = {"units": [{"key": dialogue.data.speakerKey}]}
    }
    return [
        {
            "type": "StartDialogue",
            "isImportant": true,
            "duration": Infinity,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": dialogue
                }
            ]
        },
    ]
}

export function CloseDialogue(dialogue) {
    return {
        "type": "FinishDialogue",
        "deltastages": [
            {
                "mark": 0,
                "dialogue": undefined
            }
        ]
    }
}

export function CloseRibbitScene() {
    return
}

export function DialogueChoice(text, flagname, options) {
    let speakerKey = text.substring(0, text.indexOf(":")).trim().toLowerCase() || undefined
    text = text.substring(text.indexOf(":") + 1).trim()

    return {
        "type": "StartDialogue",
        "duration": Infinity,
        "isImportant": true,
        "isUnskippable": true,
        "isBranching": true,
        "deltastages": [
            {
                "mark": 0,
                "dialogue": {
                    "type": "DialogueChoice",
                    "text": text,
                    "data": {
                        flagname, options,

                        "speakerKey": speakerKey,
                        "scene": {
                            "units": [
                                {"key": speakerKey, "isPoppingIn": true, "position": "1", "direction": "right"}
                            ]
                        }
                    }
                }
            }
        ]
    }
}

export function TransitionNothing() {
    return [
        {
            "type": "StartDialogue",
            "deltastages": [
                {
                    "dialogue": {
                        "type": "Transition",
                        "data": {
                            "phase": "nothing",
                            "doNotFuckingTouchThis": true,
                        }
                    }
                }
            ]
        }
    ]
}

export function TransitionStart({isUnskippable} = {}) {
    return [
        {
            "type": "StartDialogue",
            "duration": 2000,
            "isUnskippable": isUnskippable,
            "deltastages": [
                {
                    "dialogue": {
                        "type": "Transition",
                        "data": {
                            "phase": 0,
                            "doNotFuckingTouchThis": true,
                        }
                    }
                }
            ]
        }
    ]
}

export function TransitionEnd({isUnskippable} = {}) {
    return [
        {
            "type": "StartDialogue",
            "duration": 2000,
            "isUnskippable": isUnskippable,
            "deltastages": [
                {
                    "dialogue": {
                        "type": "Transition",
                        "data": {"phase": 1}
                    }
                }
            ]
        }
    ]
}

export function BlackoutDialogue(text) {
    return [
        {
            "type": "StartDialogue",
            "duration": Infinity,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": {
                        "type": "BlackoutDialogue",
                        "text": text,
                        "data": {
                            "doNotFuckingTouchThis": true,
                        }
                    }
                }
            ]
        }
    ]
}

export function WaitingModal({duration, label, isUnskippable}) {
    duration = duration ?? 1000
    return [
        {
            "type": "StartDialogue",
            "duration": duration,
            "isUnskippable": isUnskippable,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": {
                        "type": "Waiting",
                        "data": {label},
                    }
                }
            ]
        }
    ]
}

export function PresentationDialogue(text, presentation) {
    return {
        "type": "StartDialogue",
        "isImportant": true,
        "duration": Infinity,
        "deltastages": [
            {
                "mark": 0,
                "dialogue": {
                    "type": "PresentationDialogue",
                    "text": text,
                    "data": {
                        presentation
                    }
                }
            }
        ]
    }
}

export function CustomViewModal({view}) {
    return {
        "type": "StartDialogue",
        "isImportant": true,
        "isUnskippable": true,
        "duration": Infinity,
        "deltastages": [
            {
                "mark": 0,
                "dialogue": {
                    "type": "CustomView",
                    "data": {
                        "view": view
                    }
                }
            }
        ]
    }
}

export function ChapterSuccessClassic() {
    return {
        "duration": Infinity,
        "deltastages": [
            {
                "dialogue": {
                    "type": "ChapterSuccessClassic",
                }
            }
        ]
    }
}

export function ChapterFailure() {
    return {
        "duration": Infinity,
        "isImportant": true,
        "deltastages": [
            {
                "dialogue": {
                    "type": "ChapterFailure",
                }
            }
        ]
    }
}

export function ChapterStart(text, {isUnskippable} = {}) {
    return {
        "duration": 7000,
        "isUnskippable": isUnskippable,
        "deltastages": [
            {
                "dialogue": {
                    "type": "ChapterStart",
                    "data": {
                        text
                    }
                }
            }
        ]
    }
}

export function ChapterSuccess({message} = {}) {
    return (stage) => {
        function step({phase, duration}) {
            return {
                "duration": duration || Infinity,
                "isImportant": true,
                "deltastages": [
                    {
                        "dialogue": {
                            "type": "ChapterSuccess",
                            "data": {"phase": phase, "time": Date.now(), "message": message}
                        }
                    }
                ]
            }
        }
        let steps = [
            {
                "deltastages": [
                    {"phase": "success"}
                ]
            },
            step({"phase": 0, "duration": 100}), // blank
            step({"phase": 1, "duration": 1000}), // fade in
            step({"phase": 1.5, "duration": 1000}), // victory
            step({"phase": 2, "duration": 1000}), // stars
            step({"phase": 3, "duration": 2000}), // enemies
            step({"phase": 4, "duration": 1000}), // allies
            step({"phase": 5, "duration": 500}), // allies dead
            step({"phase": 6, "duration": 1000}), // show xp bar
        ]

        const units = Object.values(stage.units).filter((unit) => {
            return (unit.isDead == false || App.game.configuration.preserveExperienceEvenAfterDeath == true)
                && unit.affiliation == stage.player.affiliation
                && unit.type != "spot" && unit.type != "zone"
        })
        steps.push({"func": () => {
            units.forEach((unit) => {
                if(App.game.player.party.units[unit.key] != undefined) {
                    App.game.player.party.units[unit.key].experience = stage.units[unit.key].experience
                    // TODO: also preserve the unit
                }
            })
        }})

        steps.push(step({"phase": 7})) // show xp

        // TODO: handle getting SO MUCH experience that you level-up multiple times at once.
        units.forEach((unit) => {
            if(stage.units[unit.key].experience >= stage.player.party.units[unit.key].maxexperience
            && stage.player.party.units[unit.key]?.levelups[unit.level + 1] != undefined) {
                const isUnskippable = (stage.player.party.units[unit.key]?.levelups[stage.player.party.units[unit.key].level + 1] || []).find((levelupPerk) => levelupPerk.key == "jobKeys") != undefined
                if(App.game.configuration.immediateLevelups != true) {
                    steps.push({"func": () => Audiomix.trigger("Unit:Heal"), "isIgnorable": true})
                    steps.push({
                        "type": "StartDialogue",
                        "duration": Infinity,
                        "isUnskippable": isUnskippable,
                        "isImportant": true,
                        "deltastages": [
                            {
                                "dialogue": {
                                    "type": "CharacterLevelUp",
                                    "data": {
                                        "unitKey": unit.key
                                    }
                                }
                            }
                        ]
                    })
                }
                steps.push({
                    "type": "ContinueDialogue",
                    "func": (stage) => {
                        // stage.player.party.units[unit.key].experience -= App.game.player.party.units[unit.key].maxexperience
                        stage.player.party.units[unit.key].experience = 0
                        stage.player.party.units[unit.key].level += 1
                        if(stage.units[unit.key]?.levelups[stage.player.party.units[unit.key].level] == undefined) return
                        stage.units[unit.key].levelups[stage.player.party.units[unit.key].level].map((levelupPerk) => {
                            if(levelupPerk.key == "maxhealth") {
                                stage.player.party.units[unit.key].maxhealth += levelupPerk.value
                            } else if(levelupPerk.key == "maxexperience") {
                                stage.player.party.units[unit.key].maxexperience += levelupPerk.value
                            } else if(levelupPerk.key == "power") {
                                stage.player.party.units[unit.key].power = stage.player.party.units[unit.key].power || 0
                                stage.player.party.units[unit.key].power += levelupPerk.value
                            } else if(levelupPerk.key == "skill") {
                                stage.player.party.units[unit.key].unlockedSkillKeys = stage.player.party.units[unit.key].unlockedSkillKeys || []
                                stage.player.party.units[unit.key].unlockedSkillKeys.push(levelupPerk.value)
                            } else if(levelupPerk.key == "jobKey") {
                                stage.player.party.units[unit.key].jobKey = levelupPerk.value
                            } else if(levelupPerk.key == "jobKeys") {
                                stage.player.party.units[unit.key].jobKey = stage.dialogue.data.newUnitJobKey
                                stage.player.party.units[unit.key].sprites = unitJobs[stage.dialogue.data.newUnitJobKey].allysprites
                            } else if(levelupPerk.key == "sprites") {
                                stage.player.party.units[unit.key].sprites = levelupPerk.value
                            }
                        })
                    }
                })
            }
        })

        return steps
    }
}

// Flags //

function Stepflag(key, value) {
    return {
        "deltastages": [
            {
                "flag": {key, value}
            }
        ]
    }
}

// static deltaflag(key, value) {
//     return {
//         "flag": {key, value}
//     }
// }
// static flag(key, value) {
//     return {
//         "deltastages": [
//             {
//                 "flag": {key, value}
//             }
//         ]
//     }
// }

export function IdentifyWeakestUnit() {
    return (stage) => {
        let weakestUnit = undefined
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == stage.player.affiliation
            && unit.key != "priest"
            && unit.health < unit.maxhealth) {
                if(weakestUnit == undefined) {
                    weakestUnit = unit
                } else if((unit.health / unit.maxhealth) < (weakestUnit.health / weakestUnit.maxhealth)) {
                    weakestUnit = unit
                }
            }
        })

        if(weakestUnit != undefined) {
            return Stepflag("tutorial:weakUnitKey", weakestUnit.key)
        } else {
            return Stepflag("tutorial:weakUnitKey", null)
        }
    }
}

export function ResetTutorialFlags() {
    return [
        Stepflag("tutorial:hasAttacked", null),
        Stepflag("tutorial:hasKilled", null),
        Stepflag("tutorial:hasHealed", null),
        Stepflag("tutorial:hasBeenAttacked", null),
        Stepflag("tutorial:hasBeenAttackedInCounterattack", null),
        Stepflag("tutorial:hasAttackedWithoutCounterattack", null),
        Stepflag("tutorial:hasAttackedIneffectively", null),
        Stepflag("tutorial:hasAttackedEffectivelyWithEarth", null),
        Stepflag("tutorial:hasAttackedRedWithRed", null),
        Stepflag("tutorial:hasAttackedBlueWithBlue", null),
        Stepflag("tutorial:hasAttackedGreenWithGreen", null),
        Stepflag("tutorial:AttackerColor", null),
        Stepflag("tutorial:AttackedColor", null),
        Stepflag("tutorial:AttackerElement", null),
        Stepflag("tutorial:AttackedElement", null),
        Stepflag("tutorial:SuperEffectiveAttackerElement", null),
        Stepflag("tutorial:SuperEffectiveAttackedElement", null),
        Stepflag("tutorial:IneffectiveAttackerElement", null),
        Stepflag("tutorial:IneffectiveAttackedElement", null),
    ]
}

// Actions //

export function Wait(milliseconds, {isUnskippable} = {}) {
    return {
        "type": "Dialogue", // ???
        "isUnskippable": isUnskippable,
        "deltastages": [
            {
                "mark": 0,
            },
            {
                "mark": milliseconds,
            },
        ]
    }
}

export function PerformAiActions({aiAffiliations} = {}) {
    return function(stage) {
        aiAffiliations = aiAffiliations || ["bad", "neutral"]

        let steps = []
        aiAffiliations.forEach((affiliation) => {
            const ai = Stage.getAiSteps(affiliation, stage)
            steps = steps.concat(ai.steps)
            stage = steps.length > 0 ? steps[steps.length - 1].omegastage : stage
        })

        return steps
    }
}

// Stage Logic //

export function ChangeCurrentEncounter({currentEncounterKey}) {
    return {
        "deltastages": [{"currentEncounterKey": currentEncounterKey}]
    }
}

export function RespawnDeadUnits({encounterKey, protounits, healing = 1, affiliation = "bad"}) {
    return function(stage) {
        const units = Object.values(stage.units).filter((unit) => {
            return Zone.isInBounds(stage.encounters[encounterKey].zone, unit.position)
                && unit.affiliation == affiliation
        })

        return {
            "deltastages": [
                units.map((unit, index) => {
                    return {
                        "unit": {
                            "key": unit.key,
                            "isDead": false,
                            "maxhealth": unit.maxhealth * healing,
                            "health": unit.maxhealth * healing,
                            "position": {
                                "x": protounits[unit.key].position.x,
                                "y": protounits[unit.key].position.y,
                            }
                        }
                    }
                })
            ]
        }
    }
}

// Meta //

export function UpdatePlayerParty(options = {"permadeath": true}) {
    return function(stage) {
        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == stage.player.affiliation
        })

        alliedUnits.forEach((unit) => {
            if(App.game.player.party.units[unit.key] == undefined) {
                return
            }
            if(unit.affiliation != stage.player.affiliation) {
                App.game.player.party.units[unit.key].isRecruited = false
            }
            App.game.player.party.units[unit.key].isRecruited = true

            if(options.permadeath == true) {
                if(unit.isDead == true) {
                    App.game.player.party.units[unit.key].isDead = true
                    delete App.game.player.party.units[unit.key]
                }
            }
        })
    }
}

export function SaveGame({nextChapterSlug, nextPath}) {
    return {
        "func": function() {
            const savegame = {
                "player": App.game.player,
                "randomSeed": App.game.chapter.originalSeed,
                "nextPath": nextPath || (nextChapterSlug && "#/games/" + App.game.slug + "/chapters/" + nextChapterSlug)
            }
            console.info("Saving game...", savegame)

            localStorage.setItem(App.game.slug + "_savegame", JSON.stringify(savegame))
        }
    }
}

export function MarkAchievement(achievementName) {
    return {
        "func": function() {
            if(window.nativeAPI != undefined) {
                window.nativeAPI.scoreAchievement(achievementName)
            } else {
                console.warn("Does not have access to the achievement api!!!")
            }
        }
    }
}

// UNIT SPAWNING //

export function SpawnUnit(protounit) {
    return function(stage) {
        const collidingUnits = Object.values(stage.units).filter((unit) => {
            return unit.position.x == protounit.position.x
                && unit.position.y == protounit.position.y
                && unit.type != "spot" && unit.type != "zone"
        })

        if(collidingUnits.length > 0) return

        if(protounit.jobKey == undefined) delete protounit.jobKey

        return {
            "deltastages": [{"unit": protounit}]
        }
    }
}

export function SpawnUnitAtSpot({spotTag, protounit}) {
    if(spotTag == undefined) console.warn("spotTag must be defined")
    if(protounit == undefined) console.warn("protounit must be defined")
    return function(stage) {
        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }
        if(spots == undefined) return

        spots = spots.filter((spot) => {
            const collidingUnits = Object.values(stage.units).filter((unit) => {
                return unit.position.x == spot.position.x
                    && unit.position.y == spot.position.y
                    && unit.type != "spot" && unit.type != "zone"
                    && unit.isDead != true && unit.isRemoved != true
            })

            return collidingUnits.length == 0
                && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], spot.position)
        })

        const numberedNewUnits = Object.keys(stage.units).filter((key) => key.startsWith("newUnit")).map((key) => parseInt(key.split("newUnit")[1])).sort((a,b) => a - b)
        const unitKey = protounit.key || "newUnit" + ((numberedNewUnits[numberedNewUnits.length - 1] + 1) || 0)
        if(spots.length == 0) return

        let isPrioritized = false
        spots.sort((a, b) => {
            if(a.priority != undefined || b.priority != undefined) {
                isPrioritized = true
            }
            return (a.priority ?? 0) - (b.priority ?? 0)
        })

        const spot = isPrioritized ? spots[0] : stage.random.elementFromSeededKey(spots, unitKey)



        const steps = []

        steps.push(Stepdeltastage({
            "unit": {
                ...protounit,
                "key": unitKey,
                "position": {
                    "x": spot.position.x,
                    "y": spot.position.y,
                    "z": spot.position.z
                }
            }
        }))
        if(spot.direction != undefined) {
            steps.push({
                "name": "MoveUnit",
                "type": "invoke skill",
                // "isImportant": true,
                // "isUnskippable": true,
                "deltastages": [
                    {
                        "mark": 0,
                        "unit": {
                            "key": unitKey,
                            "position": {
                                "x": spot.position.x + (spot.direction?.x * -1 || 0),
                                "y": spot.position.y + (spot.direction?.y * -1 || 0),
                                "z": spot.position.z + (spot.direction?.z * -1 || 0)
                            },
                        }
                    },
                    {
                        "mark": 100,
                        "timing": Timings.easeOutQuad,
                        "motion": Motions.arc(0.5),
                        "unit": {
                            "key": unitKey,
                            "position": {
                                "x": spot.position.x,
                                "y": spot.position.y,
                                "z": spot.position.z,
                            }
                        }
                    },
                    {
                        "mark": 0,
                        "audio": {
                            "triggerKey": "Unit:Move"
                        },
                    },
                ]
            })
        }
        return steps
    }
}

export function SpawnPlayerParty(options = {}) {
    return function(stage) {
        const currentEncounterKey = stage.encounters[stage.currentEncounterKey]

        let partyUnits = Object.values(stage.player.party.units).filter((unit) => {
            // return stage.units[unit.key] == undefined
            return unit.isRecruited == true
                && unit.isDead != true
        })

        if(partyUnits.length == 0
        && options.defaultPartyUnitKeys != undefined) {
            console.log("No party units are recruited or alive!! Using the default provided party for this chapter.")
            options.defaultPartyUnitKeys.forEach((unitKey) => {
                if(stage.player.party.units[unitKey] != undefined) {
                    partyUnits.push(stage.player.party.units[unitKey])
                }
            })
        }

        let spawnSpots = Object.values(stage.units).filter((unit) => {
            return (unit.type == "zone" || unit.type == "spot")
        })

        const spotTag = options.spotTag || "goodspawn" // ??
        spawnSpots = spawnSpots.concat(Object.values(stage.world.spots).filter((spot) => spot.tag == spotTag))

        spawnSpots = spawnSpots.filter((spot) => {
            const collidingUnits = Object.values(stage.units).filter((unit) => {
                return unit.position.x == spot.position.x
                    && unit.position.y == spot.position.y
                    && unit.position.z == spot.position.z
                    && unit.type != "spot" && unit.type != "zone"
            })

            return collidingUnits.length == 0
                && (Zone.isInBounds(currentEncounterKey, spot.position) || options.isIgnoringEncounterBounds)
        })

        const deltastages = [
            spawnSpots.map((spot, index) => {
                let unit = partyUnits[index]
                if(unit == undefined) return
                unit = Objdict.merge(unit, {"position": spot.position})
                unit.spawnspot = spot
                return {
                    "unit": unit
                }
            })
        ]
        spawnSpots.forEach((spot, index) => {
            let unit = partyUnits[index]
            if(unit == undefined) return
            // deltastages.push({
            //     "flag": {
            //         "key": unit.key + "_here",
            //         "value": true
            //     }
            // })
        })

        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation != stage.player.affiliation) return
            deltastages.push({
                "unit": {
                    "key": unit.key,
                    "equippedItem": unit.diceFaces[0]
                }
            })
        })


        return {
            "deltastages": deltastages
        }
    }
}

// UNIT MOVEMENT //

export function TeleportUnit({unitKey, position}) {
    return {
        "deltastages": [
            {
                "unit": {
                    "key": unitKey,
                    "position": position,
                }
            }
        ]
    }
}

// used in the real movement of the units in the calculateActions
export function MoveUnitStep({stage, unitKey, position, duration}) {
    if(stage.units[unitKey] == undefined) return
    return {
        "name": "MoveUnit",
        "type": "invoke skill",
        "alphastage": stage,
        "deltastages": [
            {
                "mark": 0,
                "unit": {
                    "key": unitKey,
                    "position": stage.units[unitKey].position,
                }
            },
            {
                "mark": (duration || 150) * (stage.units[unitKey].moveAnimationSpeed ?? 1),
                "timing": Timings.easeOutQuad,
                "motion": stage.units[unitKey].moveAnimationType == "line" ? Motions.line : Motions.arc(0.5),
                "unit": {
                    "key": unitKey,
                    "position": position,
                }
            },
            {
                "mark": 0,
                "audio": {
                    "triggerKey": stage.units[unitKey].moveaudio || "Unit:Move"
                },
            },
        ]
    }
}

export function MoveUnit({unitKey, position, duration}) {
    return function(stage) {
        if(stage.units[unitKey] == undefined) return
        return {
            "name": "MoveUnit",
            "type": "invoke skill",
            "alphastage": stage,
            "deltastages": [
                {
                    "mark": 0,
                    "unit": {
                        "key": unitKey,
                        "position": stage.units[unitKey].position,
                    }
                },
                {
                    "mark": duration || 150,
                    "timing": Timings.easeOutQuad,
                    "motion": Motions.arc(0.5),
                    "unit": {
                        "key": unitKey,
                        "position": position,
                    }
                },
                {
                    "mark": 0,
                    "audio": {
                        "triggerKey": stage.units[unitKey].moveaudio || "Unit:Move"
                    },
                },
            ]
        }
    }
}

export function MovePlayerPartyToNewEncounter({nextEncounterKey, spawnTag, spotTag, turnNumber, doNotMoveCamera = false, duration, unitKeys, isNotAnimated, isIgnoringEncounterBounds} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounterKey]
        const nextEncounter = stage.encounters[nextEncounterKey]

        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == stage.player.affiliation
                && unit.isDead != true
                && (isIgnoringEncounterBounds == true || Zone.isInBounds(currentEncounter, unit.position))
                // && unit.properties?.includes("grunt") != true
                && (unitKeys == undefined || unitKeys.includes(unit.key))
        })

        let spawnSpots = Object.values(stage.units).filter((unit) => {
            return (unit.type == "zone" || unit.type == "spot")
                && (unit.tag == spawnTag || spawnTag == undefined)
                && Zone.isInBounds(nextEncounter, unit.position)
        })

        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }

        if(spots.length > 0) {
            spots = spots.filter((spot) => {
                const collidingUnits = Object.values(stage.units).filter((unit) => {
                    return unit.position.x == spot.position.x
                        && unit.position.y == spot.position.y
                        && unit.position.z == spot.position.z
                        && unit.type != "spot" && unit.type != "zone"
                })

                return collidingUnits.length == 0
                    && (Zone.isInBounds(nextEncounter, spot.position))
            })

            if(spots.length > 0) spawnSpots = spots
        }

        let activeEncounterKeys = undefined
        if(stage.activeEncounterKeys) {
            activeEncounterKeys = [...stage.activeEncounterKeys]
            const currentEncounterIndex = activeEncounterKeys.indexOf(stage.currentEncounterKey)
            activeEncounterKeys[currentEncounterIndex] = nextEncounterKey
            nextEncounterKey = stage.activeEncounterKeys[(currentEncounterIndex + 1) % stage.activeEncounterKeys.length]
        }

        return [
            {
                "name": "MoveUnits",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        const spawnSpot = spawnSpots[index]
                        if(spawnSpot == undefined) return undefined
                        return {"unit": {"key": unit.key, "position": spawnSpot.position, "isRemoved": false}}
                    }),
                ]
            },
            {
                "func": (stage) => {
                    if(stage.encounters[nextEncounterKey] != undefined) {
                        stage.encounters[nextEncounterKey].hasBeenSeen = true
                    }
                    if(stage.encounters[stage.currentEncounterKey] != undefined) {
                        stage.encounters[stage.currentEncounterKey].hasBeenSeen = true
                    }
                }
            },
            doNotMoveCamera == false && {
                "name": "JumpToDifferentChapterEncounter",
                "duration": 500,
                "deltastages": [
                    {"currentEncounterKey": nextEncounterKey},
                    {"activeEncounterKeys": activeEncounterKeys},
                    {"turn": {"number": turnNumber || 0, "phase": "start", "affiliation": stage.player.affiliation}},
                    {"camera": {"isNotAnimated": isNotAnimated}}
                ]
            },
            {"func": () => GameAnalytics.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + nextEncounterKey)},
            {"func": () => App.game.chapter.selection.pointer = {"position": {"x": 16 / 2, "y": 9 / 2}, "mode": "none"}},
        ]
    }
}

// this a cleaned up version of the old move party, which was trying to be far too many things for
// far too many different game loops. nowadays, we just copy and paste and edit this function for each game.
export function MovePlayerPartyToNewEncounter2({nextEncounterKey, spotTag} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounterKey]
        const nextEncounter = stage.encounters[nextEncounterKey]

        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.affiliation == stage.player.affiliation
                && Zone.isInBounds(currentEncounter, unit.position)
                // && (unitKeys == undefined || unitKeys.includes(unit.key))
        })

        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }

        if(spots.length > 0) {
            spots = spots.filter((spot) => {
                const collidingUnits = Object.values(stage.units).filter((unit) => {
                    return unit.position.x == spot.position.x
                        && unit.position.y == spot.position.y
                        && unit.position.z == spot.position.z
                        && unit.type != "spot" && unit.type != "zone"
                })

                return collidingUnits.length == 0
                    && (Zone.isInBounds(nextEncounter, spot.position))
            })

            if(spots.length > 0) spawnSpots = spots
        }

        return [
            {
                "name": "MoveUnits",
                "type": "invoke skill",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        const spawnSpot = spawnSpots[index]
                        if(spawnSpot == undefined) return undefined
                        return {
                            "mark": 0 + (index * 50),
                            "unit": {
                                "key": unit.key,
                                "position": {
                                    "x": spawnSpot.position.x,
                                    "y": spawnSpot.position.y + (spawnSpot.position.y < 9 / 2 ? -0.5 : +0.5),
                                    "z": spawnSpot.position.z,
                                },
                                "isRemoved": false,
                                "energy": {
                                    "invoke skill": true,
                                    "move": true,
                                }
                            }
                        }
                    }),
                    alliedUnits.map((unit, index) => {
                        const spawnSpot = spawnSpots[index]
                        if(spawnSpot == undefined) return undefined
                        return {
                            "mark": 150 + (index * 50),
                            "timing": Timings.easeOutQuad,
                            "motion": Motions.arc(0.5),
                            "unit": {
                                "key": unit.key,
                                "position": {
                                    "x": spawnSpot.position.x,
                                    "y": spawnSpot.position.y,
                                    "z": spawnSpot.position.z,
                                }
                            }
                        }
                    }),
                ]
            },
            // {
            //     "func": (stage) => {
            //         if(stage.encounters[nextEncounterKey] != undefined) {
            //             stage.encounters[nextEncounterKey].hasBeenSeen = true
            //         }
            //         if(stage.encounters[stage.currentEncounterKey] != undefined) {
            //             stage.encounters[stage.currentEncounterKey].hasBeenSeen = true
            //         }
            //     }
            // },
            {
                "name": "JumpToDifferentChapterEncounter",
                "deltastages": [
                    {"currentEncounterKey": nextEncounterKey},
                    {"turn": {"number": 0, "phase": "start", "affiliation": stage.player.affiliation}},
                    // {"camera": {"speed": 3000}}
                ]
            },
            {"func": () => GameAnalytics.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + nextEncounterKey)},
            {"func": () => App.game.chapter.selection.pointer = {"position": {"x": 16 / 2, "y": 9 / 2}, "mode": "none"}},
        ]
    }
}

export function JumpToDifferentChapterEncounter({nextEncounterKey}) {
    return {
        "type": "JumpToDifferentChapterEncounter",
        "duration": 2000,
        "deltastages": [
            {"currentEncounterKey": nextEncounterKey},
            {"turn": {"number": 0}}
        ]
    }
}

export function MoveEscapingUnits({spotTag} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounterKey]

        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }
        if(spots == undefined) return

        const escapingUnits = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.isRemoved != true
                && unit.affiliation == stage.player.affiliation
                && Zone.isInBounds(currentEncounter, unit.position)
                && spots.find((spot) => spot.position.x == unit.position.x && spot.position.y == unit.position.y)
        })

        let steps = []

        escapingUnits.map((unit, index) => {
            const spot = spots.find((spot) => spot.position.x == unit.position.x && spot.position.y == unit.position.y)
            steps = steps.concat([
                {"func": () => Audiomix.trigger("Unit:Door:Knell"), "isIgnorable": true},
                (unit.name || unit.title)?.toUpperCase() + " HAS ESCAPED" + (stage.currentEncounterKey == 3 ? "!!" : " TO THE NEXT ROOM."),
                {"func": () => Audiomix.trigger("Unit:Door"), "isIgnorable": true},
                {
                    "name": "MoveUnit",
                    "type": "invoke skill",
                    "deltastages": [
                        {
                            "mark": 0,
                            "unit": {
                                "key": unit.key,
                                "position": {
                                    "x": spot.position.x,
                                    "y": spot.position.y,
                                    "z": spot.position.z,
                                }
                            }
                        },
                        {
                            "mark": 300,
                            "timing": Timings.easeOutQuad,
                            "motion": Motions.arc(0.5),
                            "unit": {
                                "key": unit.key,
                                "isRemoved": true,
                                "position": {
                                    "x": spot.position.x + (spot.direction?.x || 0),
                                    "y": spot.position.y + (spot.direction?.y || 0),
                                    "z": spot.position.z + (spot.direction?.z || 0)
                                },
                            }
                        },
                        {
                            "mark": 0,
                            "audio": {
                                "triggerKey": "Unit:Move"
                            },
                        },
                    ]
                },
                // Stepdeltastage({
                //     "unit": {
                //         "key": unit.key,
                //         "isRemoved": true,
                //         "position": {
                //             "x": spot.position.x,
                //             "y": spot.position.y,
                //             "z": spot.position.z,
                //         }
                //     }
                // }),
            ])
        })

        return steps
    }
}

export function MoveUnitToSpot({unitKey, spotTag}) {
    return function(stage) {
        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }
        if(spots == undefined) return

        spots = spots.filter((spot) => {
            const collidingUnits = Object.values(stage.units).filter((unit) => {
                return unit.position.x == spot.position.x
                    && unit.position.y == spot.position.y
                    && unit.isDead != true
                    && unit.isRemoved != true
            })

            return collidingUnits.length == 0
        })

        let isPrioritized = false
        spots.sort((a, b) => {
            if(a.priority != undefined || b.priority != undefined) {
                isPrioritized = true
            }
            return (a.priority ?? 0) - (b.priority ?? 0)
        })

        if(spots.length == 0) return
        const spot = isPrioritized ? spots[0] : stage.random.elementFromSeededKey(spots, unitKey)

        if(spot.direction != undefined) {
            return {
                "name": "MoveUnit",
                "type": "invoke skill",
                "deltastages": [
                    {
                        "mark": 0,
                        "unit": {
                            "key": unitKey,
                            "position": {
                                "x": spot.position.x + (spot.direction?.x * -1 || 0),
                                "y": spot.position.y + (spot.direction?.y * -1 || 0),
                                "z": spot.position.z + (spot.direction?.z * -1 || 0)
                            },
                        }
                    },
                    {
                        "mark": 100,
                        "timing": Timings.easeOutQuad,
                        "motion": Motions.arc(0.5),
                        "unit": {
                            "key": unitKey,
                            "position": {
                                "x": spot.position.x,
                                "y": spot.position.y,
                                "z": spot.position.z,
                            }
                        }
                    },
                    {
                        "mark": 0,
                        "audio": {
                            "triggerKey": "Unit:Move"
                        },
                    },
                ]
            }
        }
        return {
            "deltastages": [
                {
                    "unit": {
                        "key": unitKey,
                        "position": {
                            "x": spot.position.x,
                            "y": spot.position.y,
                            "z": spot.position.z
                        }
                    }
                }
            ]
        }
    }
}

// UNIT EDITING //

export function HealPlayerParty({percent, isDead = false} = {}) {
    percent = percent ?? 0.5
    return function(stage) {
        const currentEncounterKey = stage.encounters[stage.currentEncounterKey]
        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == stage.player.affiliation
                && !!unit.isDead == isDead
                && Zone.isInBounds(currentEncounterKey, unit.position)
        })

        return [
            {
                "name": "HealUnits",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        return {
                            "unit": {
                                "key": unit.key,
                                "isDead": false,
                                "health": Math.min(unit.maxhealth, unit.health + (unit.maxhealth * percent)),
                            }
                        }
                    }),
                ]
            },
        ]
    }
}

export function EditUnit(unit) {
    return {"deltastages": [{"unit": unit}]}
}

// export function kickUnitsOutOfFaction(faction) {
//     return (stage) => {
//         return Object.values(stage.units).filter((unit) => {
//             return unit.properties.includes(faction) == false
//         }).map((unit) => {
//             return Stepdeltastage({
//                 "unit": {
//                     "key": unit.key,
//                     "affiliation": "good"
//                 }
//             })
//         }).concat([
//             Stepdeltastage({
//                 "player": {
//                     "affiliation": "good"
//                 }
//             })
//         ])
//     }
// }






// ANALYTICS //

// EXAMPLE PLOTSCRIPT:
// {
//     "type": "turn:every:end",
//     "events": [
//         PlotSteps.ReportEndTurnAnalytics(),
//     ]
// }
export function ReportEndTurnAnalytics() {
    return (stage) => {
        return [
            {"func": () => GameAnalytics._.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey, "turn-" + stage.turn.number)},
        ]
    }
}

// EXAMPLE PLOTSCRIPT:
// {
//     "type": "turn:every:start",
//     "events": [
//         PlotSteps.ReportStartTurnAnalytics(),
//     ]
// }
export function ReportStartTurnAnalytics() {
    return (stage) => {
        return [
            {"func": () => GameAnalytics._.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey, "turn-" + stage.turn.number)},
        ]
    }
}

export function ReportStartingAnalytics() {
    return (stage) => {
        return [
            {"func": () => GameAnalytics.reportStageStart("chapter-" + stage.chapterSlug)},
            {"func": () => GameAnalytics.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics._.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey, "turn-" + stage.turn.number)},
        ]
    }
}

export function ReportSuccessAnalytics() {
    return (stage) => {
        return [
            {"func": () => GameAnalytics.reportStageSuccess("chapter-" + stage.chapterSlug)},
            {"func": () => GameAnalytics.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics._.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey, "turn-" + stage.turn.number)},
        ]
    }
}

export function ReportFailureAnalytics() {
    return (stage) => {
        return [
            {"func": () => GameAnalytics.reportStageFailure("chapter-" + stage.chapterSlug)},
            {"func": () => GameAnalytics.reportStageFailure("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics._.reportStageFailure("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey, "turn-" + stage.turn.number)},
        ]
    }
}

// AUDIO //

export function PlayAudio(audiokey) {
    return {
        "func": () => Audiomix.trigger(audiokey)
    }
}

export function KillAudio({label}) {
    return {
        "func": () => Audiomix.kill({label})
    }
}

// Why use PlayStinger over PlayAudio?
// When you want to play a one-off short sound
// that doens't need to be played if the entire
// cutscene is skipped over. (Otherwise, every
// single stinger would be played all at once
// when we skip through the cutscene.)
export function PlayStinger(audiokey) {
    return {
        "func": () => Audiomix.trigger(audiokey),
        "isIgnorable": true
    }
}
